import React from 'react';
import PropTypes from 'prop-types';
import '@fiverr/globals';
import { trackEvent } from '../../utils/tracking.js';
import { withGigCardContext } from '../gig_card_context';
import './style.scss';

const Price = ({ gigUrl, price, cardType, cardSize, abTests, averagePrice, medianPrice, showStartingAt, isLimitedEdition, isPlusPrice, onLinkClick }) => {
    const classes = ['gig-price'],
        avgMedPriceEnum = {
            2: averagePrice ? `${i18n.t('price.on_average')} ${averagePrice}` : null,
            3: medianPrice ? `${i18n.t('price.most_successful')} ${medianPrice}` : null
        },
        inAvgMedVariation = avgMedPriceEnum.hasOwnProperty(abTests.AVG_MEDIAN_PRICE_2),
        subPrice = avgMedPriceEnum[abTests.AVG_MEDIAN_PRICE_2];

    const onClick = (e) => {
        trackEvent('price', cardType, cardSize);
        onLinkClick(e);
    };

    if (isPlusPrice) {
        showStartingAt = false;
        if (price) {
            price = `${price}+`;
        }

    }

    let prefix = showStartingAt ? i18n.t('price.starting_at') : '';

    if (isLimitedEdition) {
        prefix = i18n.t('price.only');
    }

    inAvgMedVariation && classes.push('med-avg-price');

    return (
        <div className={classes.join(' ')}>
            <a className="js-gig-card-imp-data" href={gigUrl} onClick={onClick}>
                {prefix && <small>{prefix}</small>}
                {price}
                {subPrice && <div className="gig-sub-price">{subPrice}</div>}
            </a>
        </div>
    );
};

Price.propTypes = {
    gigUrl: PropTypes.string.isRequired,
    price: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    cardType: PropTypes.string,
    showStartingAt: PropTypes.bool,
    averagePrice: PropTypes.string,
    medianPrice: PropTypes.string,
    onLinkClick: PropTypes.func
};

Price.defaultProps = {
    abTests: {},
    onLinkClick: () => null
};

const contextSelector = ({ cardType, cardSize, abTests }) => ({ cardType, cardSize, abTests });

export default withGigCardContext(contextSelector)(Price);



// WEBPACK FOOTER //
// ./src/shared/price/index.js